import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaClienteFilterModule } from '../filter';
import { ClienteListModule } from '../../../../pessoa/cliente/list/cliente-list.module';

import { CampanhaClienteViewComponent } from './campanha-cliente-view.component';

@NgModule({
    imports: [
        SharedModule,
        CampanhaClienteFilterModule,
        ClienteListModule
    ],
    declarations: [
        CampanhaClienteViewComponent
    ],
    exports: [
        CampanhaClienteViewComponent
    ]
})
export class CampanhaClienteViewModule { }
